import React from 'react';
import { TextLink, TextLinkProps, usePopupManager } from 'ui-builder';
import { ConfirmDeletePopup } from '../ConfirmDeletePopup';

export interface TextDeleteLinkProps extends Omit<TextLinkProps, 'onClick'> {
  deleteFunc: () => Promise<void>,
  deleteMessage: string
}

export function TextDeleteLink(props: TextDeleteLinkProps) {
  const popupManager = usePopupManager();

  return (
    <TextLink
      {...props}
      onClick={async () => {
        popupManager.openPopup(
          <ConfirmDeletePopup
            deleteFunc={props.deleteFunc}
            message={props.deleteMessage}
          />
        );
      }}
    >
      {props.children}
    </TextLink>
  );
}
